import * as BABYLON from '@babylonjs/core/Legacy/legacy';
import { Rectangle, Control } from '@babylonjs/gui/2D';

import { GameScene } from '../scene.js';

const log = console.log.bind(console);

export abstract class Particle2D {
    private lifeCycle: number;
    private lifeCycleCount: number = 0;
    private isDie: boolean = false;
    abstract control: Control;

    abstract dispose(): void;
    
    constructor(lifeCycle: number) {
        this.lifeCycle = lifeCycle;
    }

    update() {
        this.lifeCycleCount += 1
        if (this.lifeCycleCount >= this.lifeCycle) {
            this.isDie = true;
            return;
        }
    }

    getIsDie(): boolean {
        return this.isDie;
    }

    live() {
        this.lifeCycleCount = 0
        this.isDie = false
    }

    getControl(): Control {
        return this.control;
    }

    getPercent(): number {
        return this.lifeCycleCount / this.lifeCycle
    }
}


function randomRange(min:number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}


export class YellowCoin2D extends Particle2D {
    control: Control;
    cp: number[];

    constructor() {
        super(100 + randomRange(-20, 20))

        var rect = new Rectangle();
        rect.width = rect.height = '20px';
        rect.color = "Orange";
        rect.thickness = 2;
        rect.background = "Orange";

        this.control = rect

        this.cp = [24 + randomRange(-20, 20), 91 + randomRange(-20, 20)]

    }

    dispose(): void {
        this.control.dispose()
    }

    update(): void {
        super.update()

        // 旋转
        this.control.rotation += 0.12

        // 贝塞尔曲线 路径
        const quadBezier = function(t: number, p1: number[], cp: number[], p2: number[]): number[] {
            const [x1, y1] = p1;
            const [cx, cy] = cp;
            const [x2, y2] = p2;
            let x = (1 - t) * (1 - t) * x1 + 2 * t * (1 - t) * cx + t * t * x2;
            let y = (1 - t) * (1 - t) * y1 + 2 * t * (1 - t) * cy + t * t * y2;
            return [x, y];
        }


        // t 从 0.0 变化到 1.0
        let t = this.getPercent()
        // cp 是初始化得到的随机控制点
        let cp = this.cp
        let p1 = [0, 0]
        let p2 = [100, 100]
        let res = quadBezier(t, p1, cp, p2)

        // 按贝塞尔结果位置 对应实际屏幕的最终位置
        let pos1 = [0, 300]
        let pos2 = [-180, 40]
        let posX = pos1[0] + res[0] / 100 * (pos2[0] - pos1[0])
        let posY = pos1[1] + res[1] / 100 * (pos2[1] - pos1[1])

        this.control.left = posX
        this.control.top = posY

        // 颜色的渐变, 固定控制点就好, 不需要随机
        cp = [100, 30]
        res = quadBezier(t, p1, cp, p2)
        this.control.alpha = 1 - res[1] / 100
    }
}



